/**
 *
 * @author Igor Zapororzhets <deadbyelpy@gmail.com>.
 */

'use strict';


/* eslint no-use-before-define: 0*/
/* eslint no-useless-call: 0 */

var app  = require('mag-app'),
    keys = require('stb-keys'),

    Modal = require('mag-component-modal'),
    List  = require('mag-component-layout-list'),
    Scroll          = require('stb-component-scrollbar'),
    // ScrollArea      = require('mag-component-scroll-area'),

    nodeMap = require('../node.map.js'),
    listItemRender = require('./list.item'),

    scroll = new Scroll({}),
    // textArea = new ScrollArea({
    //     propagate: true,
    //     step: 5,
    //     scroll: scroll
    // }),


    list = new List({
        propagate: true,
        size: 7,
        focusIndex: 0,
        scroll: scroll,
        noData: 'No channels',
        // data: [[1]],
        // render: function ( $node, data ) {
        //     if ( !$node.$layout ) {
        //         $node.innerText = '';

        //         while ( $node.firstChild ) {
        //             $node.removeChild($node.firstChild);
        //         }

        //         $node.$layout = $node.appendChild(document.createElement('div'));
        //         $node.$layout.className = 'mag-component-layout';

        //         $node.$text = document.createElement('div');

        //         $node.$layout.appendChild($node.$text);
        //     }

        //     $node.$text.innerText = data.name || data.value;
        // },
        events: {
            keydown: function ( event ) {
                // List.prototype.defaultEvents.keydown.call(this, event);

                switch ( event.code ) {
                    case keys.back:
                        event.stop = true;
                        modal.hide();
                        break;

                    default:
                        if ( this.highlightFocus ) {
                            List.prototype.defaultEvents.keydown.call(this, event);
                        } else if ( event.code === keys.down ) {
                            this.move(keys.pageDown);
                        } else if ( event.code === keys.up ) {
                            this.move(keys.pageUp);
                        } else {
                            this.move(event.code);
                        }
                        break;
                }
            },
            'focus:item': function ( event ) {
                if ( !this.highlightFocus ) {
                    // if ( event.$prev ) {
                    //     event.$prev.classList.remove('focus');
                    // }
                    event.$curr.classList.remove('focus');
                }
            },
            'move:view': function () {
                modal.$counter.firstChild.innerText = this.data.length;
            }
        }
    }),
    modal = new Modal({
        title: 'Choose',
        children: [
            list,
            scroll
        ],
        events: {
            show: function () {
                app.activePanelSet.blur();
                list.focus();
                list.focusIndex(0);
            },
            hide: function () {
                app.activePanelSet.focus();
            }
        }
    }),
    currentOption;


// textArea.add(list);
modal.$node.classList.add('select-list');
// list.$node.className = 'mag-component-layout-list padded';
// list.$node.appendChild(list.$body);
// list.$body.className = 'body';
// list.$body.title = '';

modal.$counter = modal.$text.parentNode.appendChild(document.createElement('div'));
modal.$counter.className = 'theme-counter';
modal.$counter.appendChild(document.createElement('div'));
modal.$counter.firstChild.className = '';
list.$node.className = 'mag-component-layout-list padded table-like';


function showModal ( option, data ) {
    currentOption = option;
    // currentOption.list.forEach(function ( item, index ) {
    //     if ( item.selected ) {
    //         currentOption.focusIndex = index;
    //     }
    // });


    modal.$text.innerText = self.title || gettext('Choose option');

    modal.$counter.firstChild.innerText = data.length;
    console.log(modal.$counter.innerHTML);

    if ( modal.parent ) {
        if ( app.activePage !== modal.parent ) {
            modal.parent.remove(modal);
            app.activePage.add(modal);
        }
    } else {
        app.activePage.add(modal);
    }

    list.init({
        size: data.length > 5 ? 5 : data.length,
        data: data
    });

    if ( currentOption.events.click && currentOption.events.click.length > 0  ) {
        currentOption.events.click[0].call(list);
    }
    list.highlightFocus = currentOption.config.focusable;

    setTimeout(function () {
        modal.show();
    }, 0);
}


module.exports = function ( data, callback ) {
    var self = this;

    // self.focusIndex = 0;

    // data.forEach(function ( item, index ) {
    //     if ( item.selected ) {
    //         self.focusIndex = index;
    //     }
    // });
    // self.list = data;

    if ( !this.config ) {
        this.config = {
            focusable: true
        };
    }

    listItemRender.call(this, null, function () {
        nodeMap.data[self.id].onclick = function () {
            if ( self.warningText ) {
                require('../utils/confirm')(self.warningText, function ( result ) {
                    if ( result ) {
                        showModal(self, data);
                    }
                });
            } else {
                showModal(self, data);
            }
        };

        callback();
    });
};
